module.exports = __webpack_public_path__ + "media/images/pic/testimonials/gabrysia-b85dc046b67cb23a1faa1fe3a75ded62.webp";